import fetch from "./fetch";

/**
 获取所有字典类型列表
 **/
export function fetchAllDicList() {
	return fetch({
		url: "/dics",
		method: "get"
	});
}

//所有书籍
export function nameList() {
	return fetch({
		url: '/books/book_name/list',
		method: 'get',
	})
}






// WEBPACK FOOTER //
// ./src/api/common.js